import * as React from 'react';

import { Stack } from '@mui/system';

import { Card } from '@itp/talent/components/core/card';
import { NestedPageLayout } from '@itp/talent/components/layout/components/nestedPageLayout';

export type AuthCardProps = {
  children: React.ReactNode;
};

export const AuthCard: React.FC<AuthCardProps> = ({ children }) => {
  return (
    <NestedPageLayout>
      <NestedPageLayout.PageContainer>
        <NestedPageLayout.MainContent
          alignItems="center"
          display="flex"
          justifyContent="center"
          sx={{ height: 'calc(100vh - 100px)' }}
        >
          <Card sx={{ maxWidth: '520px', width: '100%' }}>
            <Card.Content>
              <Stack gap={3}>{children}</Stack>
            </Card.Content>
          </Card>
        </NestedPageLayout.MainContent>
      </NestedPageLayout.PageContainer>
    </NestedPageLayout>
  );
};
